import React, { useState, useEffect, useRef } from 'react'
import { GiphyFetch } from "@giphy/js-fetch-api"
import { Grid } from "@giphy/react-components"

const Giphy = ({
    selectGiphy,
    isBigChat,
    openCallout,
}) => {
    const giphySearch = useRef(null)

    const [searchTerm, setSearchTerm] = useState('')

	const giphyFetch = new GiphyFetch("qXSjO3vccTmMg49RNZMtBZ5Wnrck2Fj7")
	const fetchGifs = () => giphyFetch.search(searchTerm, { sort: 'relevant', limit: isBigChat ? 20: 10 })

    function handleChange(event) {
        setSearchTerm(event.target.value)
    }

    useEffect(() => {
        setTimeout(() => {
            if (giphySearch.current) {
                giphySearch.current.focus()
            }
        }, 100)
        if ( openCallout !== 'giphy' ) {
            setTimeout(() => {
                setSearchTerm('')
            }, 100)
        }
    }, [openCallout])

    return (
        <div className="giphy-popup-inside">
            <input
                ref={giphySearch}
                type="text"
                onChange={handleChange}
                placeholder="Search Giphy"
                value={searchTerm}
            />
            <div className="giphy-grid-cont">
                { ( fetchGifs && searchTerm ) ?
                    <Grid
                        key={searchTerm}
                        fetchGifs={fetchGifs}
                        width={isBigChat ? 460 : 260}
                        columns={3}
                        gutter={6}
                        onGifClick={gif => selectGiphy(gif)}
                        noLink={true}
                        hideAttribution={true}
                    />
                :
                    <div className="giphy-grid-empty">
                        <p>Enter search term above.</p>
                        <img 
                            src={document.base + "/images/giphy.gif"}
                        />
                        <img 
                            src={document.base + "/images/giphy-light.gif"}
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default Giphy



// WEBPACK FOOTER //
// ./src/layout/dock/giphy.jsx